export default __webpack_public_path__ + "static/media/env.7cfc65b1.png";